import React, { useState, useEffect } from 'react';
import './login.css'; // Make sure to update your CSS file
import { useNavigate } from 'react-router-dom';
import { BE_URL } from '../constants';

const host = BE_URL; //"http://localhost:5100";

export default function Auth() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(''); // Generic message state for both success and error
  const [isError, setIsError] = useState(false); // State to determine the type of message
  const [showAlert, setShowAlert] = useState(false);
  const [isLogin, setIsLogin] = useState(true); // State to toggle between Login and Register

  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (message) {
      setShowAlert(true);
      timer = setTimeout(() => {
        setShowAlert(false);
        if (!isError && !isLogin) {
          // Navigate to login if registration is successful and we're on the registration page
          setIsLogin(true);
          setUsername('');
          setPassword('');
        }
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const endpoint = isLogin ? 'api/users/login' : 'api/register';

    try {
      // alert('Submit')
      const response = await fetch(`${host}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      if (response.ok) {
        // alert('done')
        const data = await response.json();
        console.log(`${isLogin ? 'Login' : 'Registration'} successful`);
        console.log(data);

        if (isLogin) {
          navigate('/dashboard');
        }
      if (!isLogin && window.location.pathname === '/dashboard') {
          navigate('/login');
        }
        else {
          setMessage('User registered successfully');
          setIsError(false);
        }
      } else {
        const data = await response.json();
        setMessage(data.message || `${isLogin ? 'Login' : 'Registration'} failed`);
        setIsError(true);
        console.error(`${isLogin ? 'Login' : 'Registration'} failed`, data.message);
      }
    } catch (error) {
      setMessage(`${isLogin ? 'Login' : 'Registration'} failed`);
      setIsError(true);
      console.error(`${isLogin ? 'Login' : 'Registration'} failed`, error);
    }
  };

  return (
    <div className="auth-container">
      {message && (
        <div className={`alert ${showAlert ? 'show' : 'hide'} ${isError ? 'error' : 'success'}`}>
          {message}
        </div>
      )}
      <div className="auth-forms">
        <form onSubmit={handleSubmit} className="auth-form">
          <center><h2>{isLogin ? 'Login' : 'Register'}</h2></center>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              placeholder='Enter Username'
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder='Enter Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className='btn' type="submit">{isLogin ? 'Login' : 'Register'}</button>
          <p>
            {isLogin ? 'Don\'t have an account?' : 'Already have an account?'}
            <button type="button" onClick={() => setIsLogin(!isLogin)}>
              {isLogin ? 'Register here' : 'Login here'}
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}
